import React from 'react';
const Dashboard = React.lazy(() => import('./views/Dashboard'));
const Reporting = React.lazy(() => import('./archers_reporting/Reporting'));
const CheckListTracking = React.lazy(() => import('./archers_reporting/CheckListTracking'));
const Users = React.lazy(() => import('./archers_users/UsersList'));
const AddUser = React.lazy(() => import('./archers_users/AddUser'));
const UpdateUser = React.lazy(() => import('./archers_users/UpdateUser'));
const ResetPassword = React.lazy(() => import('./archers_users/ResetPassword'));
const ProfileUser = React.lazy(() => import('./archers_users/ProfileUser'));

const ListTasksAll = React.lazy(() => import('./archers_tasks/ListTasksAll'));
const ListTasksInitiates = React.lazy(() => import('./archers_tasks/ListTasksInitiates'));
const ListTasksCompleted = React.lazy(() => import('./archers_tasks/ListTasksCompleted'));
const ListTasksInProgress = React.lazy(() => import('./archers_tasks/ListTasksInProgress'));
const TaskReviewIndexFilter = React.lazy(() => import('./archers_tasks_review/TaskReviewIndexFilter'));
const TaskReviewIndex = React.lazy(() => import('./archers_tasks_review/TaskReviewIndex'));
const ItemsList = React.lazy(() => import('./archers_items/ItemsList'));
const AddItem = React.lazy(() => import('./archers_items/AddItem'));
const UpdateItem = React.lazy(() => import('./archers_items/UpdateItem'));
//const SortItemCat = React.lazy(() => import('./archers_categories/ItemsListByCategorie'));
const Categories = React.lazy(() => import('./archers_categories/ItemsListByCategory'));

const routes = [
  { path: '/', role:'all',exact: true, name: 'Home' },
  { path: '/dashboard', role:'all', name: 'Dashboard', component: Dashboard },
  { path: '/categories', role:'all', name: 'Items', component: Categories },
  { path: '/tasks_tracking', role:'all', name: 'Reporting', component: Reporting },
  { path: '/checklist_tracking', role:'all', name: 'Reporting', component: CheckListTracking },
  { path: '/users', role:'super_admin', exact: true,  name: 'Users', component: Users },
  { path: '/users/update-user/:username',role:'super_admin', exact: true, name: 'Update User', component: UpdateUser },
  { path: '/users/reset-password/:section',role:'admin', exact: true, name: 'Update User', component: ResetPassword },
  { path: '/addUser',role:'super_admin', exact: true, name: 'Add User', component: AddUser },
  { path: '/profile/:username',role:'all', exact: true, name: 'Profile', component: ProfileUser },
  { path: '/all_tasks', role:'admin', exact: true,  name: 'All Tasks', component: ListTasksAll },
  { path: '/tasks/initiates', role:'admin', exact: true,  name: 'Initiates', component: ListTasksInitiates},
  { path: '/tasks/inprogress', role:'admin', exact: true,  name: 'In progress', component: ListTasksInProgress},
  { path: '/tasks/completed', role:'admin', exact: true,  name: 'Completed', component: ListTasksCompleted},
  { path: '/tasks', role:'admin', exact: true,  name: 'All tasks', component: ListTasksAll },

  { path: '/tasks/task-review/:id', role:'admin_exclusif', exact: true,  name: 'Review', component: TaskReviewIndexFilter},
  { path: '/tasks/task-review/:id', role:'super_admin', exact: true,  name: 'Review', component: TaskReviewIndex},

  { path: '/items', role:'super_admin', exact: true,  name: 'All items', component: ItemsList},
  { path: '/addItem', role:'super_admin', exact: true,  name: 'Add Item', component: AddItem},
  { path: '/items/update-item/:itemId', role:'super_admin', exact: true,  name: 'Update Item', component: UpdateItem},
];

export default routes;
